import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IconModule } from 'src/app/icon/icon.module';
import { CompanyService } from 'src/app/services/company.service';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { TableService } from 'src/app/services/table.service';
import { UserService } from 'src/app/services/user.service';
import { PARAM_OPERATOR, ROUTES } from 'src/app/shared/constants';

@Component({
  selector: 'app-company-layout',
  imports: [RouterModule, TranslateModule, IconModule],
  templateUrl: './company-layout.component.html',
  styleUrl: './company-layout.component.scss'
})
export class CompanyLayoutComponent implements OnInit, OnDestroy {
  company: any;
  companyId?: number;
  userCount = 0;

  private subscriptions: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyService: CompanyService,
    private breadcrumbService: BreadcrumbService,
    private tableService: TableService,
    private userService: UserService
  ) {}

  get isAdmin(): boolean {
    return this.router.url.startsWith('/admin');
  }

  get companyInitial(): string {
    return this.company?.name?.trim().charAt(0).toUpperCase() ?? '';
  }

  ngOnInit(): void {
    if (!this.isAdmin) return;

    this.companyId = Number(this.route.snapshot.params['companyId']);
    if (!Number.isFinite(this.companyId)) return;

    this.subscriptions.push(
      this.companyService.getCompany(this.companyId).subscribe(company => {
        this.company = company;
        this.breadcrumbService.setIntermediateBreadcrumb({
          afterTitle: 'companies',
          title: company.name,
          url: `/admin/companies/${this.companyId}`
        });
      }),
      this.userService.getUsers({
        page: 1,
        pageSize: 1,
        filterText: `companyId[${PARAM_OPERATOR.EQUAL}]${this.companyId}`
      }).subscribe((response: any) => this.userCount = response.totalRecord ?? response.data?.length ?? response.length ?? 0)
    );
  }

  close(): void {
    this.tableService.markForRestore('company-table');
    this.router.navigate([ROUTES.ADMIN.COMPANIES]);
  }

  ngOnDestroy(): void {
    this.breadcrumbService.setIntermediateBreadcrumb(null);
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
